<template lang="">
    <nav class="navbg navbar navbar-expand-lg navbar-light fixed-top" >
        <div class="container">
            <button v-if="categories.length" class="navbar-toggler" type="button" data-toggle="collapse"
                data-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <a :href="base_url" class="navbar-brand mb-0" style="font-weight: bold;">
                <span class="indexlogo">五湖園生命智慧園區</span>
            </a>
            <cart-status v-if="isLogin" ref="cartStatus" :href="base_url" class="cartbtn-sm" :text="text"></cart-status>
            <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
                <ul class="navbar-nav mt-2 mt-lg-0">
                    <li class="nav-item dropdown" v-if="categories.length">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="color: white;">
                            所有分類
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" :href="base_url + '/category-new/' + item" v-for="(item, index) in allCategories" style="color: black;" v-show="!(item == categories[0])">
                                {{ item }}
                            </a>
                        </div>
                    </li>
                    <!-- <li v-for="(item, index) in categories" :key="index" class="nav-item">
                        <a class="nav-link" data-turbolinks="false" :href="'#'+item">{{item}} <span
                                class="sr-only">(current)</span></a>
                    </li> -->
                </ul>
            </div>
            <cart-status v-if="isLogin" ref="cartStatus" :href="base_url" class="cartbtn-lg" :text="text"></cart-status>
        </div>
    </nav>
</template>
<script>
import eventHub from '../library/eventHub';
export default {
    props: {
        text: {
            default: 0,
        },
    },
    data() {
        return {
            isLogin: this.text == 0 ? false : true,
            categories: [],
            allCategories: {},
            base_url,
        }
    },
    mounted() {
        eventHub.$on('categoryupdate', this.categoryupdate)
        eventHub.$on('allcategory', this.allCategory)
    },
    methods: {
        categoryupdate(input) {
            this.categories.push(input);
        },
        allCategory(input) {
            this.allCategories = input.children.filter(function (c) { return c.state }).map(function (c) { return c.name });
        }
    },
}
</script>
<style scoped>
.navbg {
    background-color: #7A8473;
}

.indexlogo {
    color: #f9f9f9;
    font-size: 1.25em;
}

.navbg li a {
    color: #f9f9f9;
}

.navbg li a:hover {
    color: black;
}
</style>
